import { render } from "./AssetView.vue?vue&type=template&id=209a98ee&ts=true"
import script from "./AssetView.vue?vue&type=script&lang=ts"
export * from "./AssetView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__